export default __webpack_public_path__ + "static/media/usecase-car.c0712e6c.jpg";